module.exports = __webpack_public_path__ + "media/images/front/icons/columns-7207b0e114b79aef89801d3222880b1d.png";